/**
 * Paroi de douche
 */
import * as THREE from "three";
import CustomObject from '../CustomObject.js'

export default class ShowerWall extends CustomObject
{
    constructor(modelPath, position, id, scale, subType, rotation, aimantee, rideauLeste) {
        
        super(modelPath, position, id, rotation);
        this.type = "showerWall";
        this.scale = scale;
        this.aimantee = aimantee || 0;
        this.rideauLeste = rideauLeste || 0;

        this.subType = subType;
        /* if(this.subType === "rabat" && this.rotation == null) {
            this.rotation = new THREE.Euler(0,Math.PI/4,0);
        } */
        this.position.y = 0.05;
        this.collisionAllowed = true;
        this.snappingAllowed = true;
        this.axesMove = [true, false, true]; // x, y
        
    }
}